import { Box, Center, ChakraProvider, Spinner, Text } from '@chakra-ui/react'
import '@fontsource/karla/400-italic.css'
import '@fontsource/karla/400.css'
import '@fontsource/karla/700.css'
import { QueryClientProvider } from 'react-query'
import useAuth from './hooks/useAuth'
import useFetchConfig from './hooks/useFetchConfig'
import useFetchContent from './hooks/useFetchContent'
import useFetchDoctors from './hooks/useFetchDoctors'
import useFetchUserData from './hooks/useFetchUserData'
import useStore from './store/useStore'
import { theme } from './theme'
import Footer from './components/layout/Footer'
import Header from './components/layout/Header'
import MainContent from './components/layout/MainContent'
import useIdentityProvider from './hooks/useIdentityProvider'
import { queryClient } from './utils/queryClient'
import ImpersonationErrorBoundary from './components/ImpersonationErrorBoundary'

export default () => {
  const user = useStore((state) => state.user)
  const identityStatus = useStore((state) => state.identityStatus)

  useAuth()
  useIdentityProvider()
  useFetchDoctors()
  useFetchUserData()
  useFetchConfig()
  useFetchContent()

  if (user === undefined) return null

  if (identityStatus === 'verifying' || identityStatus === 'invalidating') {
    return (
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <Box display='flex' flexDirection='column' minHeight='100vh'>
            <Header />
            <Center as='main' flex='1' gap={4} flexDirection='column'>
              <Spinner size='xl' color='purple.500' thickness='4px' />
              <Text color='gray.600'>Switching user session...</Text>
            </Center>
            <Footer />
          </Box>
        </ChakraProvider>
      </QueryClientProvider>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <Box display='flex' flexDirection='column' minHeight='100vh'>
          <Header />
          <ImpersonationErrorBoundary>
            <MainContent />
          </ImpersonationErrorBoundary>
          <Footer />
        </Box>
      </ChakraProvider>
    </QueryClientProvider>
  )
}
